import React from 'react';

import { TermsAndConditions as TermsAndConditionsComponent } from '@bessemercws/components';
import { Typography } from '@bessemercws/components/bui';

import { FullScreenTermsAndConditions } from './Terms.styles';

export const Terms = () => {
  return (
    <FullScreenTermsAndConditions data-testid="terms-of-use">
      <Typography variant="h3">Terms of Use</Typography>
      <TermsAndConditionsComponent />
    </FullScreenTermsAndConditions>
  );
};
